export default __webpack_public_path__ + "static/media/youtubeIcon.d2dc6e4e.svg";